// extracted by mini-css-extract-plugin
module.exports = {"authNav":"authNav__341UH"};